<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="edit category">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="3">
              <label class="font-weight-medium body-2">
                Academic Year
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete key="id" label="Select Academic Year" :items="academicYears"
                v-model="selectedAcademicYear" required item-text="academicYear" item-value="id"
                :hide-details="true" readonly>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="font-weight-medium body-2">
                Audit Type
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete key="id" label="Select Type " :items="auditList"
                v-model="selectedAuditType" required item-text="auditType" item-value="id">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <label class="font-weight-medium body-2">
                Position
              </label>
              <v-text-field type="number" min="1" max="100" placeholder="Enter position"
                v-model.trim="position" maxlength="100"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="font-weight-medium body-2">
                Category Name
                <span class="requir error--text">*</span>
              </label>
              <v-text-field counter="100" required v-model.trim="categoryName"
                placeholder="Category Name" maxlength="100"></v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2">
                Subcategories
              </label>

              <div v-for="(n, i) of subCategory" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <v-text-field title="Position" class="my-0 py-1" min="1" type="number"
                            placeholder="Position" v-model.trim="subCategory[i].position"
                            maxlength="100">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="10">
                          <v-text-field class="my-0 py-1" counter="100"
                            placeholder="Subcategory name" :required="i === 0"
                            v-model.trim="subCategory[i].subCategoryName" maxlength="100">
                          </v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" md="6" v-if="showParam">
                          <v-text-field class="my-0 py-1" counter="100" placeholder="Remark"
                            v-model.trim="prmtr[i].remark" maxlength="100"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" v-if="showParam">
                          <v-text-field class="my-0 py-1" counter="100" placeholder="Description"
                            v-model.trim="prmtr[i].description" maxlength="100"></v-text-field>
                        </v-col> -->
                      </v-row>
                    </v-col>
                    <!-- <v-col cols="12" md="1"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center">
                      <label class="font-weight-medium body-2">No. {{ i + 1 }}</label>

                      <v-card-actions>
                        <v-btn title="Delete Subcategory" elevation="1" color="error"
                          @click="deleteRow(i, subCategory[i])">
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col> -->
                  </v-row>
                </v-card-component>
              </div>
              <v-card-actions class="d-flex justify-end">
                <!-- <v-btn bottom right elevation="1" color="primary" @click="
                    subCategory.push({
                      name: '',
                      //remark: '',
                      //description: '',
                      position: '',
                      isActive: true
                    })
                  ">
                  <v-icon left> mdi-plus </v-icon>
                  Add Subcategory
                </v-btn> -->
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save all
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
// import { mapGetters } from 'vuex'
import _ from 'lodash'
import Utils from '@/utils'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['categoryId'],
  data () {
    return {
      categoryName: '',
      selectedAcademicYear: '',
      academicYears: [],
      position: 0,
      showParam: false,
      subCategory: [
        {
          id: '',
          subCategoryName: ''
          // position: '',
          // isActive: true
        }
      ],
      auditList: [],
      auditType: '',
      auditTypeID: '',
      selectedAuditType: '',
      isEdit: false,
      deleteSubcategories: []
    }
  },
  created: async function () {
    await this.getYear()
    await this.getAuditList()
    if (this.categoryId) {
      this.isEdit = true
      await this.getCategoryDetails()
    }
  },
  watch: {},
  methods: {
    getCategoryDetails: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/audit/audit-category/getbyid/${this.categoryId}`)
        this.name = res.data.name
        this.position = res.data.position
        this.categoryName = res.data.categoryName
        this.selectedAuditType = res.data.auditTypeID
        this.selectedAcademicYear = res.data.academicYearID
        this.subCategory = res.data.subCategory
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    deleteSubcategory: async function (parameterId) {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/audit/audit-subcategory/delete/${parameterId}`)
        console.log('Delete subcategory response: ', res)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    deleteMultipleSubcategories: async function (arr, isActive = false) {
      try {
        if (arr.length > 0) {
          await http.put(`${CONSTANTS.API_URL}/api/center-audit/parameter/all/status`, {
            parameters: arr,
            isActive: isActive
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    save: async function () {
      try {
        // await this.deleteMultipleParameters(this.deleteParameters)

        // if (this.isEdit) {
        //   this.prmtr.map(a => {
        //     // delete a.id
        //     if (!a.id) {
        //       a.id = ''
        //     }
        //     delete a.categoryID
        //     return a
        //   })
        // }

        this.sections = this.subCategory.map(obj => {
          return {
            id: obj.id,
            categoryName: obj.categoryName
            // sections: obj.studentSections
          }
        })
        let formData = {
          categoryName: this.categoryName,
          // auditType: this.auditTypeID,
          // auditTypeID: '4a776e11-1ec0-4f23-8da7-498bc62dccdc',
          // academicYearID: this.selectedAcademicYear,
          // position: this.position,
          // isActive: true,
          subCategories: this.sections
        }

        let res = await http.put(`${CONSTANTS.API_URL}/api/audit/audit-category/update/${this.categoryId}`, formData)
        this.okMsg(res.data)
        this.$router.push({ name: 'generallistAuditCategory' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getAuditList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${CONSTANTS.API_URL}/api/audit/audit-type/get-all-audit-type`)
        this.auditList = data
        this.auditTypeID = this.auditList.id
        this.isLoading = false

        return this.auditList
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching role', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${CONSTANTS.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.academicYears = response.data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.selectedAcademicYear = academicYear.id
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteRow (e, item) {
      if (item.id) {
        this.deleteSubcategories.push(item.id)
        // this.deleteParameter(item.id)
      }
      if (this.subCategory.length > 1) {
        this.subCategory = _.filter(this.subCategory, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one subcategory is required!')
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style></style>
